export default __webpack_public_path__ + "static/media/hc-9.5eb427c8.mp4";